import styles from "./RequiredCodeTag.module.scss";
import { useRequiredCode } from "../index/useRequiredCode.ts";
import { Book } from "../../../../common/api/decimal/methods/course.ts";
import MiscellaneousExclamationCircle from "common/icons/MiscellaneousExclamationCircle.tsx";
import { useIntl } from "react-intl";

export default function RequiredCodeTag({
  code,
}: {
  code: Book["requiredCode"];
}) {
  const intl = useIntl();
  const codeLabel = useRequiredCode({ requiredCode: code });
  const needsExclamation = code === "required";
  const a11yLabel = intl.formatMessage({ defaultMessage: "Attention" });

  if (!codeLabel) {
    return null;
  }

  return (
    <span className={styles.container}>
      {needsExclamation && (
        <MiscellaneousExclamationCircle
          aria-hidden={false}
          aria-label={a11yLabel}
        />
      )}
      {codeLabel}
    </span>
  );
}
